<div class="pi-itmseqGrid" style="background:white; padding: 10px">
    <div class="pi-dropdownlist">
        <app-categories (categoryOutput)="categoryClicked()" [page]="'profile-items'"></app-categories>
    </div>
    <div class="pi-itemGrid">
        <kendo-grid #grid 
                    (cancel)="cancelHandler()" 
                    (cellClick)="cellClickHandler($event)"
                    (dataStateChange)="dataStateChange($event)"
                    (pageChange)="pageChange($event)"
                    (selectionChange)="selectionChangeHandler($event)"
                    [data]="gridData"
                    [filter]="state.filter"
                    [filterable]="true"
                    [navigable]="true"
                    [pageSize]="state.take"
                    [reorderable]="true"
                    [resizable]="true"
                    [rowHeight]="36"
                    [selectable]="true"
                    [skip]="state.skip"
                    [sort]="state.sort"
                    [sortable]="true"
                    (excelExport)="excelExported($event)"
                    id="productsGrid"
                    scrollable="virtual"
                    style="height: 500px">
            <ng-template kendoGridToolbarTemplate>
                <kendo-grid-spacer></kendo-grid-spacer>
                <app-mcl-button id="but-export" (buttonPressed)="exportToPDF(grid)" text="Export to PDF"
                            [svgIcon]='filePdfIcon' primary="true"></app-mcl-button>
                <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(grid)"  [svgIcon]="fileExcelIcon"  primary="true" text="Export to Excel"></app-mcl-button>
            </ng-template>
            <kendo-grid-column [editable]="columns[0].editable" [editor]="columns[0].editor" [field]="columns[0].field"
                               [format]="columns[0].format" [ngStyle]="{'width.px': columns[0].width}"
                               [title]="columns[0].title"
                               sortable="true">
                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    <p *ngIf="gridData">
                        {{gridData.total}} Item(s)</p>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [editable]="columns[1].editable" [editor]="columns[1].editor" [field]="columns[1].field"
                               [format]="columns[1].format" width="280"
                               [title]="columns[1].title"
                               sortable="true">

            </kendo-grid-column>

            <kendo-grid-column [editable]="columns[2].editable" [editor]="columns[2].editor" [field]="columns[2].field"
                               [filterable]="false" [format]="columns[2].format"
                               [ngStyle]="{'width.px': columns[2].width}"
                               [title]="columns[2].title"
                               sortable="true">


            </kendo-grid-column>
            <kendo-grid-column [editable]="columns[3].editable" [editor]="columns[3].editor" [field]="columns[3].field"
                               [format]="columns[3].format" [ngStyle]="{'width.px': columns[3].width}"
                               [title]="columns[3].title"
                               filter="boolean"
                               sortable="true">

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <input [checked]="dataItem.show" disabled="disabled" type="checkbox"/>
                </ng-template>

            </kendo-grid-column>
            <kendo-grid-column [editable]="columns[4].editable" [editor]="columns[4].editor" [field]="columns[4].field"
                               [format]="columns[4].format" [ngStyle]="{'width.px': columns[4].width}"
                               [title]="columns[4].title"
                               filter="boolean"
                               sortable="true">

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <input [checked]="dataItem.critical" disabled="disabled" type="checkbox"/>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [editable]="columns[5].editable" [editor]="columns[5].editor" [field]="columns[5].field"
                               [format]="'n2'"
                               [ngStyle]="{'width.px': columns[4].width}" [title]="columns[5].title" filter="numeric"
                               sortable="true">
                <ng-template kendoGridFilterCellTemplate let-column="column" let-filter>
                    <kendo-grid-numeric-filter-cell
                            [column]="column"
                            [filter]="filter"
                            [min]=0
                            [max]="999999999">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column [editable]="columns[6].editable" [editor]="columns[6].editor" [field]="columns[6].field"
                               [format]="columns[6].format"
                               [ngStyle]="{'width.px': columns[6].width}" [title]="columns[6].title" filter="numeric"
                               sortable="true">
                <ng-template kendoGridFilterCellTemplate let-column="column" let-filter>
                    <kendo-grid-numeric-filter-cell
                            [column]="column"
                            [filter]="filter"
                            [min]=0
                            [max]="999999999">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>

            </kendo-grid-column>
            <kendo-grid-column [editable]="columns[7].editable" [editor]="columns[7].editor" [field]="columns[7].field"
                               [format]="columns[7].format"
                               [ngStyle]="{'width.px': columns[7].width}" [title]="columns[7].title" filter="numeric"
                               sortable="true">
                <ng-template kendoGridFilterCellTemplate let-column="column" let-filter>
                    <kendo-grid-numeric-filter-cell
                            [column]="column"
                            [filter]="filter"
                            [min]=0
                            [max]="9999999999">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-pdf fileName="MasterItemList.pdf" [author]="'McLane'" [producer]="'McLane'" [allPages]="true" paperSize="A4" [repeatHeaders]="false" [scale]="0.8" >
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="1cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">

                    <div class="page-template">
                        <div class="header" *ngIf="pageNum == 1">
                            <p>SourceLink - Master Item List</p>
                            <p>Store: {{_storeListService.pickedIdentity}}</p>
                            <p>Category: {{_profileCategoriesService.selectedCategory.description}}</p>
                        </div>
                        <div class="header" *ngIf="pageNum != 1">

                        </div>
                    </div>
                </ng-template>

                <kendo-grid-column [field]="columns[0].field" [format]="columns[0].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" [style]="{'font-size': '9px'}" [title]="columns[0].title" width="60">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                            Item<br>Number
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [field]="columns[1].field" [format]="columns[1].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" [style]="{'font-size': '9px'}" [title]="columns[1].title" width="180"></kendo-grid-column>
                <kendo-grid-column [field]="columns[2].field" [format]="columns[2].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" [style]="{'font-size': '9px'}" [title]="columns[2].title" width="70">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                           Unit<br> of <br> Measure                   
                        </div>  
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [field]="columns[3].field" [format]="columns[3].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" [style]="{'font-size': '9px'}" [title]="columns[3].title" width="60">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                           Show<br> Item                
                        </div>  
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <p>{{dataItem.show ? 'Yes' : 'No'}}</p>
                    </ng-template>
                </kendo-grid-column> 
                <kendo-grid-column [field]="columns[4].field" [format]="columns[4].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" [style]="{'font-size': '9px'}" [title]="columns[4].title" width="60">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                           Critical <br> Item         
                        </div>  
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <p>{{dataItem.critical ? 'Yes' : 'No'}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [field]="columns[5].field" [format]="'n2'" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}"  [style]="{'font-size': '9px'}" [title]="columns[5].title" width="60">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                           Build <br> To <br> Item         
                        </div>  
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [field]="columns[6].field" [format]="columns[6].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" [style]="{'font-size': '9px'}" [title]="columns[6].title" width="60">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                           Max <br> Quantity      
                        </div>  
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [field]="columns[7].field" [format]="columns[7].format" [headerStyle]="{'font-size': '9px','line-height': '1.2','white-space': 'normal', 'text-align': 'right'}" [style]="{'font-size': '9px'}" [title]="columns[7].title" width="80"></kendo-grid-column>

            </kendo-grid-pdf>
            <kendo-grid-excel fileName="MasterItemList.xlsx" [fetchData]="exportAllData">
                <kendo-excelexport-column [field]="columns[0].field" [style]="{'font-size': '10px'}" [title]="columns[0].title"></kendo-excelexport-column>
                <kendo-excelexport-column [field]="columns[1].field"  [style]="{'font-size': '10px'}" [title]="columns[1].title"></kendo-excelexport-column>
                <kendo-excelexport-column [field]="columns[2].field" [style]="{'font-size': '10px'}" [title]="columns[2].title"></kendo-excelexport-column>
                <kendo-excelexport-column field="showString" [style]="{'font-size': '10px'}" [title]="columns[3].title">
                </kendo-excelexport-column>
                <kendo-excelexport-column field="criticalString" [style]="{'font-size': '10px'}" [title]="columns[4].title">
                </kendo-excelexport-column>
                <kendo-excelexport-column [field]="columns[5].field"   [style]="{'font-size': '10px'}" [title]="columns[5].title"></kendo-excelexport-column>
                <kendo-excelexport-column [field]="columns[6].field"  [style]="{'font-size': '10px'}" [title]="columns[6].title"></kendo-excelexport-column>
                <kendo-excelexport-column [field]="columns[7].field" [style]="{'font-size': '10px'}" [title]="columns[7].title" ></kendo-excelexport-column>

            </kendo-grid-excel>
        </kendo-grid>
    </div>
    <div class="buttonflex">
        <app-mcl-button (buttonPressed)="_profileService.saveAllItems()" [disabled]="!_profileService.itemsSaved || formGroup?.invalid" primary="true"
                    text="Save Items" icon="save"></app-mcl-button>
    </div>
</div>
<div kendoDialogContainer></div>
